import { CLEAR_ALL, LOGOUT } from '../../../../store/Types';

export const ALL_PEVA_ACTIVIDADES = 'ALL_PEVA_ACTIVIDADES';
export const ACTIVO_PEVA_ACTIVIDADES = 'ACTIVO_PEVA_ACTIVIDADES';
export const LOADING_ALL_PEVA_ACTIVIDADES = 'LOADING_ALL_PEVA_ACTIVIDADES';
export const LOADING_UPDATE_ESTATUS_PEVA_ACTIVIDADES =
  'LOADING_UPDATE_ESTATUS_PEVA_ACTIVIDADES';
export const PARAMS_PEVA_ACTIVIDADES = 'PARAMS_PEVA_ACTIVIDADES';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  loadingUpdateEstatus: false,
  params: {},
};

export const pevaActividadesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_PEVA_ACTIVIDADES:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_PEVA_ACTIVIDADES:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_ALL_PEVA_ACTIVIDADES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case LOADING_UPDATE_ESTATUS_PEVA_ACTIVIDADES:
    case PARAMS_PEVA_ACTIVIDADES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
